var React = require('react');

function Sun32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 17h-6a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2zm-7.293-7.793a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l4-4a.999.999 0 1 1 1.414 1.414l-4 4zM16 21.5c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm0-10c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM16 8a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v6a1 1 0 0 1-1 1zM9 9.5a.997.997 0 0 1-.707-.293l-4-4a.999.999 0 1 1 1.414-1.414l4 4A.999.999 0 0 1 9 9.5zM8 16a1 1 0 0 1-1 1H1a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1zm.293 5.793a.999.999 0 1 1 1.414 1.414l-4 4a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414l4-4zM16 24a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0v-6a1 1 0 0 1 1-1zm7.707-2.207l4 4a.999.999 0 1 1-1.414 1.414l-4-4a.999.999 0 1 1 1.414-1.414z","key":1})]);
}

Sun32px.displayName = "Sun32px";

Sun32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};

module.exports = Sun32px;

Sun32px.default = Sun32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/sun-32px.svg
// module id = 1114
// module chunks = 0